import type { KAPLAYCtx } from '../types.ts'
import type { RoomOptions } from '../types.ts'
import { useLang } from '../providers/i18n/i18n.ts'
import { useGameUiTextFrame } from '../objects/game-ui-text-frame.ts'
import { getTiledSize, parsePolygon, getFileCacheStr } from '../utils.ts'

export function useFocusRoomA(k: KAPLAYCtx) {
  const cacheStr = getFileCacheStr()
  k.loadSprite('focusRoomA', `sprites/rooms/focus-room-a.png?${cacheStr}`)
  k.loadSprite('focusRoomAHover', `sprites/rooms/focus-room-a--hover.png?${cacheStr}`)
  const collidersJson = k.loadJSON(
    'focusRoomAColliders',
    `colliders/focus-room-a.parsed.json?${cacheStr}`,
  )

  const { showTextFrame } = useGameUiTextFrame(k)
  const { getLangString } = useLang(k)

  function setFocusRoomA(roomOpts?: RoomOptions) {
    roomOpts = roomOpts || {}

    const roomObj = k.add()

    k.onLoad(() => {
      const { data } = collidersJson

      roomObj.add([
        k.sprite('focusRoomA', {
          width: getTiledSize(data.width),
          height: getTiledSize(data.height),
        }),
        k.layer('background'),
        'focus_room_a_background',
        'background',
      ])

      roomObj.add([
        k.sprite('focusRoomAHover', {
          width: getTiledSize(data.width),
          height: getTiledSize(data.height),
        }),
        k.layer('hover'),
        'focus_room_a_hover',
        'hover',
      ])

      data.objects.forEach((obj: any) => {
        const poly = parsePolygon(k, obj)
        roomObj.add([k.pos(), k.area({ shape: poly }), k.body({ isStatic: true }), 'colliders'])
      })

      roomObj.add([
        k.level(['       ', '       ', '       ', '  ?   1', '       ', '       '], {
          tileWidth: getTiledSize(),
          tileHeight: getTiledSize(),
          tiles: {
            '1': () => [
              k.rect(getTiledSize(0.5), getTiledSize(), { fill: false }),
              k.area({ isSensor: true }),
              'focus_room_a_door_exit',
              'door_exit',
              'door',
            ],
            '?': () => [
              k.sprite('overlay', { anim: 'question' }),
              k.area({ isSensor: true }),
              k.layer('background'),
              'focus_room_a_info',
              'sfx_emit_action',
              'info',
            ],
          },
        }),
        k.layer('objects'),
        'focus_room_a',
      ])

      // Set player position
      k.get('player')[0]?.setPos(k.vec2(getTiledSize(5.5), getTiledSize(3)))

      const doorExitCollision = k.onCollide('player', 'focus_room_a_door_exit', () => {
        k.flash(k.BLACK, 0.5)
        roomObj.destroy()
        doorExitCollision.cancel()
        infoCollision.cancel()
        infoCollisionEnd.cancel()
        if (roomOpts.onExit) roomOpts.onExit()
      })

      const infoCollision = k.onCollide('player', 'focus_room_a_info', () => {
        showTextFrame(getLangString('focus_room_info'))
      })

      const infoCollisionEnd = k.onCollideEnd('player', 'focus_room_a_info', () => {
        showTextFrame()
      })
    })

    return roomObj
  }

  return {
    setFocusRoomA,
  }
}
